import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from '../../../business/misc/info/aboutus/async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route
    key="/consumer/about-us"
    element={
      <DefaultConsumerLayout
        // backgroundImage={require('../../../../assets/images/consumer/about-us-bg.jpg')}
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Consumer',
            item: '/consumer',
          },
          {
            position: 3,
            name: 'About us',
            item: '/consumer/about-us',
          },
        ]}
      />
    }
  >
    <Route path="consumer/about-us" element={<AsyncPage />} />
  </Route>
);
